// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"22336779","186":"33e7f70d","472":"067ed7eb","622":"d7898853","863":"f92a5268","908":"421f8e23"}[chunkId] + ".chunk.js";
};